module.exports = __webpack_public_path__ + "images/56827a87a5d8e46fe46bc33d62ccf4fa.png";